import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

interface VerifyOtpVariables {
    token: string;
}

// see api code for notes on why username/password is sent down
export const useVerifyOtp = (username: string, password: string) => {
    const mutation = useMutation({
        mutationFn: async (variables: VerifyOtpVariables) => {
            const data = {
                username: username,
                password: password,
                token: variables.token,
            }

            return axios.post(`${API_BASE}/api/session/otp`, data);
        },
    });

    return mutation;
}
